<script setup lang="ts">
import { tokenService } from '~/api/service/token.service'
import TokenCard from '~/components/@pages/tokens/TokenCard.vue'
import DetailsBox from '~/components/box/DetailsBox.vue'
import PageTitleHeader from '~/components/header/PageTitleHeader.vue'
import TokensTransferTable from '~/components/table/tokens-transfer/TokensTransferTable.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25,
})

const { data, isLoading } = tokenService.useGetTokenTransferList(pagination)
const { data: tokenCardData } = tokenService.useGetTokenCardList()

useSeoMeta(getMeta('All Tokens', 'View the All Tokens'))

useHead(getBreadCrumb())
</script>

<template>
  <div class="flex flex-col gap-y-8">
    <div class="flex flex-col gap-y-4">
      <PageTitleHeader title="All Tokens" />
      <div class="token-card-container">
        <TokenCard
          v-for="token in tokenCardData?.tokenCardList"
          :key="token.symbol"
          :token="token"
        />
      </div>
    </div>
    <div class="flex flex-col gap-y-4">
      <PageTitleHeader title="Token Transfers" />
      <div>
        <DetailsBox class="mb-2">
          Showing all <span class="text-primary">{{ data?.formattedTotalCount }}</span> results
          <template #pagination>
            <BcPagination
              v-model="pagination"
              :row-per-page-list="rowPerPageList"
              :total-count="data?.viewCount"
              hide-rows-per-page
            />
          </template>
        </DetailsBox>
        <Card>
          <TokensTransferTable
            :rows="data?.transferList || []"
            :is-loading="isLoading"
            :row-cnt="pagination.rowPerPage"
          />
          <BcPagination
            v-model="pagination"
            :row-per-page-list="rowPerPageList"
            :total-count="data?.viewCount"
          />
        </Card>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.token-card-container {
  @apply flex justify-between gap-x-4;

  @include sm {
    @apply flex-col gap-y-4;
  }
}
</style>
